module.exports = __webpack_public_path__ + "static/media/blendi-klosi.64eaa1da.jpg";